function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-47.1%",
  y: "-47.1%",
  width: "194.1%",
  height: "194.1%",
  filterUnits: "objectBoundingBox",
  id: "a"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.172412817 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "3.061617e-15%",
  id: "b"
}, React.createElement("stop", {
  stopColor: "#FFE37B",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FFD166",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  filter: "url(#a)",
  fillRule: "nonzero"
}, React.createElement("circle", {
  fill: "url(#b)",
  cx: 8.5,
  cy: 8.5,
  r: 8.5
}), React.createElement("path", {
  d: "M8.5,16.15 C8.5,12.7249783 8.5,4.27502166 8.5,0.85 C4.27502166,0.85 0.85,4.27502166 0.85,8.5 C0.85,12.7249783 4.27502166,16.15 8.5,16.15 Z",
  fill: "#FFFFFF"
})));

const SvgHalfDoneIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "17px",
  height: "17px",
  viewBox: "0 0 17 17",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHalfDoneIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/half-done-icon.99f9117e.svg";
export { ForwardRef as ReactComponent };